/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cookie-disabled',
  templateUrl: './cookie-disabled.component.html',
  styleUrls: ['./cookie-disabled.component.scss']
})
export class CookieDisabledComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
